/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */
import {
    GET_PAYMENT_USED_TO_PLACE_ORDER,
    UPDATE_PAYMENT_USED_TO_PLACE_ORDER,
} from './OrderPlacedPayment-ActionTypes';

export const getPaymentUsedToPlaceOrder = () => ({
    type: GET_PAYMENT_USED_TO_PLACE_ORDER,
});

export const updatePaymentUsedToPlaceOrder = (data) => ({
    type: UPDATE_PAYMENT_USED_TO_PLACE_ORDER,
    data,
});
